module.exports = __webpack_public_path__ + "img/market_dropdown.7344e837.png";